var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQrCode = function SvgIconQrCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F2F4F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-qr-code_svg__a",
    width: 50,
    height: 50,
    x: 10,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 12h49.54v49.54H10z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-qr-code_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M33.63 24.96h4.57m-6.1-4.58h1.53M22.96 35.63v1.52m-4.58-1.52v4.57m0 0h3.05m3.81 0h6.86m0-11.43h1.53m-1.53 6.86v6.86m0 10.66h19.05m-10.66 0v-3.04m10.66 3.04v-3.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5C0DE",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M28.3 20.38h-9.92v9.91h9.91v-9.9Zm22.85 0h-9.9v9.91h9.9v-9.9ZM28.3 43.25h-9.92v9.9h9.91v-9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M26.77 35.63h5.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.24 23.43h-3.8v3.81h3.8v-3.8Zm22.86 0h-3.8v3.81h3.8v-3.8ZM25.24 46.3h-3.8v3.8h3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M38.2 20.38v8.39m12.95 6.86v6.86m-15.24-7.63h2.29m.76 2.29v5.34m-3.05-4.58h5.34M32.1 46.3v2.28m0-2.28h6.86m-3.05 0v2.28m7.62-6.09h3.05M44.3 46.3v2.28m3.8-2.28h3.05M32.1 42.49h3.05m-8.38-6.86v1.52m14.48.76v-2.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.81 19.76V15.8h4.13m37.46 3.96V15.8h-4.13M13.81 53.78v3.95h4.13m37.46-3.95v3.95h-4.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E73E34",
    d: "M55.73 31.82H13.8v2.28h41.92v-2.28Z"
  }))));
};
export default SvgIconQrCode;